import React, { useState, useEffect } from "react";
import logo from "./img/logo2.png";
import botft from "./img/botft.png";
import { Link, useLocation } from "react-router-dom";
import {
  faHeart as faStarEmpty,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  ExternalLink,
  Clock,
  Mail,
  Facebook,
  Linkedin,
  Instagram,
  Twitter,
  X,
  LogOut as UsersIcon,
} from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  const [currentYear, setCurrentYear] = useState("");

  useEffect(() => {
    // Set the current year when the component mounts
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);

  useEffect(() => {
    // Add LinkedIn Partner ID script
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.innerHTML = `
      _linkedin_partner_id = "7988497";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
    document.body.appendChild(script1);

    // Add LinkedIn Insight Analytics script
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.async = true;
    script2.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    document.body.appendChild(script2);

    // Add fallback noscript image for browsers with JavaScript disabled
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=7988497&fmt=gif" />
    `;
    document.body.appendChild(noscript);

    return () => {
      // Cleanup the scripts when the component unmounts
      document.body.removeChild(script1);
      document.body.removeChild(script2);
      document.body.removeChild(noscript);
    };
  }, []);

  return (
    <>
      <div className="">
        <div className="neftbg app-hide">
          <div className="bottom_brdr">
            <div className="dark_clr"></div>
            <div className="light_clr"></div>
          </div>
          <div className="footer_newnov ">
            <div className="ftnewnovmain ftnew">
              <div className="leftfotmenu">
                <ul>
                  <li className="ftnovact ovrtb">
                    <a href="https://app.evventoz.com/" target="_blank">
                      Publish Your Events
                    </a>
                  </li>
                  <li className="quitb">
                    <a href="https://app.evventoz.com/" target="_blank">
                      Promote Your Events
                    </a>
                  </li>
                  {/* <li className="popltb">
          <a href="https://app.evventoz.com/" target="_blank">Sell Tickets Online</a>
          </li> */}
                  {/* <li className="interytb">
          <a href="/">Pricing Plans</a>
          </li> */}
                  <li className="polairtb">
                    <a href="https://app.evventoz.com/" target="_blank">
                      Event Manager App
                    </a>
                  </li>
                  {/* <li className="connttb">
          <Link to="/">Rank Your Event</Link>
          </li> */}
                  <li className="offertb">
                    <a href="https://app.evventoz.com/" target="_blank">
                      Event Listing
                    </a>
                  </li>

                  {/* <a href="https://www.easemytrip.com/career.html" target="_blank" className="lastelement">
            CURRENT OPENINGS
            <span className="neftr" style={{
  left: "139px"
}}
>
              New
            </span>
          </a> */}
                </ul>
              </div>
              <div className="rightfotmenu">
                <div className="menuft1 ftnew flxwrp">
                  <p className="f-para">
                    Make your event planning seamless with our comprehensive
                    range of services
                  </p>
                  <div className="menulinkx">
                    <ul>
                      <li>
                        <Link to="/login" target="_blank">
                          My Account
                        </Link>
                      </li>
                      <li>
                        <a href="https://blog.evventoz.com/" target="_blank">
                          Blogs
                        </a>
                      </li>

                      {/* <li>
                <Link to="/my-events" target="_blank">
                My Events
                </Link>
              </li> */}

                      <li>
                        <Link to="/about-us" target="_blank">
                          About Us
                        </Link>
                      </li>

                      <li>
                        <Link to="/help-support" target="_blank">
                          Evventoz FAQs
                        </Link>
                      </li>

                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>

                      <li>
                        <Link to="/privacy-policy" target="_blank">
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions" target="_blank">
                          Terms and Conditions
                        </Link>
                      </li>
                      <li>
                        <Link to="/disclamer" target="_blank">
                          Disclamer
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="text-start mt-5">
                  <h6 className="text-white">
                    <strong>Connect with Us Online</strong>
                  </h6>

                  <div className="d-flex">
                    <div className="me-2">
                      <a
                        href="https://www.facebook.com/profile.php?id=61560048915788"
                        target="_blank"
                      >
                        <Facebook className="ic text-white" size={25} />{" "}
                      </a>
                    </div>

                    <div className="me-2">
                      <a
                        href="https://www.instagram.com/evventoz/"
                        target="_blank"
                      >
                        <Instagram className="ic text-white" size={25} />{" "}
                      </a>
                    </div>

                    <div className="me-2">
                      <a href="https://x.com/evventoz" target="_blank">
                        <FontAwesomeIcon
                          icon={faXTwitter}
                          size={25}
                          className="text-white"
                        />{" "}
                      </a>
                    </div>

                    <div className="me-2">
                      <a
                        href="https://www.linkedin.com/company/evventoz/"
                        target="_blank"
                      >
                        <Linkedin size={25} className=" text-white" />{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="novftlast ftnew">
            <div className="d-flex">
              <div className="ndert text-white">
                Copyright © 2024 - {currentYear} <span>Evventoz.com</span>{" "}
                <span>All Rights Reserved</span>
              </div>
              <div className="ndertimhgt">
                <img src={botft} alt="EaseMyTrip" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
